import { FC, SVGProps } from "react";

export const ParallelChannelIcon: FC<SVGProps<SVGSVGElement>> = ({
  fill = "white",
  className,
  width = 16,
  height = 16,
  style,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 206 198.1"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        ...style,
      }}
      {...props}
    >
      <path
        d="M147.9 31.1c2.5 4.9 4.8 9.3 7.3 14.2-32.4 16.7-64.5 33.2-96.9 50-2.5-4.8-4.8-9.2-7.4-14.2 32.4-16.7 64.4-33.2 97-50zm-12.6 103.6c0 12.2-10.1 22.5-22.1 22.6-12.5 0-22.8-10-22.9-22.3-.1-12.2 9.9-22.6 21.9-22.8 12.7-.3 23 9.8 23.1 22.5zM205.8 23c-.2 12.4-10.7 22.3-23.1 22-12.2-.3-22-10.5-21.8-22.8C161 9.7 171.2-.2 183.8 0c12.4.2 22.3 10.5 22 23zM.8 104.5C1 92.2 11.4 82 23.2 82.3c12.9.3 22.8 10.6 22.5 23.2-.3 12.2-10.7 22.2-22.7 21.9C10.5 127.1.5 116.8.8 104.5zm84.6 53.3c-26.1 13.4-52 26.7-78.5 40.3-2.2-4.7-4.4-9.3-6.9-14.6 25.9-13.3 51.6-26.5 77.8-39.9 2.6 4.8 4.9 9.2 7.6 14.2zm62.4-32.6c-2.6-5-4.8-9.3-7.4-14.3 19.7-10.2 39.1-20.3 58.9-30.5 2.3 5 4.3 9.5 6.7 14.6-19.2 10-38.3 19.9-58.2 30.2z"
        fill={fill}
      ></path>
    </svg>
  );
};
